// Количеството на съставка в „Инфо" → „Съставки" (режим със склад).
//
// Знаците са тези на мерната единица (`decimalPlaces`, както навсякъде в
// склада — `formatQty`), но НИКОГА по-малко от знаците в самата стойност:
// порцията често е дробна и в цели единици (½ яйце при „бр" с 0 знака), а
// закръгленото „1 бр" би излъгало кухнята. Под-рецептата няма единица —
// показва толкова знаци, колкото има стойността. Таванът е 4 (`clampDecimals`).
import type { RecipeIngredientLine } from "../../../../api/menu";
import { clampDecimals, formatQty } from "../../../inventory/components/qty";

/** Decimal от BE (JSON низ) → число; непарсваемо → 0. */
export function parseIngredientQuantity(quantity: string): number {
  const value = Number(quantity);
  return Number.isFinite(value) ? value : 0;
}

/** Колко знака след точката носи десетичният низ („0.015" → 3, „2" → 0). */
export function fractionDigitsOf(quantity: string): number {
  // Експонентен запис („1E-7") — пределът на формата
  if (/e/i.test(quantity)) return 4;
  const fraction = quantity.split(".")[1] ?? "";
  return Math.min(4, fraction.replace(/0+$/, "").length);
}

/** „0,240" (кг, 3 знака) · „0,5" (бр, ½) · „0,06" (под-рецепта). */
export function formatIngredientQuantity(line: RecipeIngredientLine): string {
  const unitDecimals =
    line.kind === "recipe" ? 0 : clampDecimals(line.decimalPlaces);
  return formatQty(
    parseIngredientQuantity(line.quantity),
    Math.max(unitDecimals, fractionDigitsOf(line.quantity)),
  );
}
